'use-client';
import { replaceTokensInString } from '@cat-ecom/common/utils/stringUtils';
import {
  DealerLocatorHeader,
  DealerLocatorStoreDetailsDrawerBody,
  DealerStore
} from '@cat-ecom/pcc-components';
import { CONTACT_US_DEALER } from 'constants/endpoints';
import { useTranslations } from 'next-intl';
import { useEsiteCtx } from 'services/esite/context';
import { normalizeUrl } from 'utils/url';

interface DealerLocatorStoreDetailsDrawerContentrProps {
  selectedStoreObjDrawer: DealerStore;
  onBackButtonClick: () => void;
  unitOfMeasure: 'mi' | 'km';
  closestLabel: string;
  isStoreLocationListViewUpdateFlag: boolean;
  isStoreLocationMapViewUpdateFlag: boolean;
  isStoreLocationOptimizationFlag: boolean;
}

export const DealerLocatorStoreDetailsDrawerContent = ({
  selectedStoreObjDrawer,
  onBackButtonClick,
  unitOfMeasure,
  closestLabel,
  isStoreLocationListViewUpdateFlag,
  isStoreLocationMapViewUpdateFlag,
  isStoreLocationOptimizationFlag
}: DealerLocatorStoreDetailsDrawerContentrProps) => {
  const t = useTranslations();
  const { catalogId, langId } = useEsiteCtx();
  const returnContactUrl = (dealerStoreId?: string) =>
    normalizeUrl(
      replaceTokensInString(
        `${CONTACT_US_DEALER}`,
        catalogId,
        langId,
        dealerStoreId
      )
    );
  return (
    <>
      <DealerLocatorHeader
        title={t('INV_STORE_DETAILS')}
        onBackButtonClick={onBackButtonClick}
      />
      <DealerLocatorStoreDetailsDrawerBody
        selectedStoreObjDrawer={selectedStoreObjDrawer}
        unitOfMeasure={unitOfMeasure}
        closestLabel={closestLabel}
        isStoreLocationListViewUpdateFlag={isStoreLocationListViewUpdateFlag}
        isStoreLocationMapViewUpdateFlag={isStoreLocationMapViewUpdateFlag}
        isStoreLocationOptimizationFlag={isStoreLocationOptimizationFlag}
        contactInfoDrivingDirectionsLabel={t('DRIVING_DIRECTIONS')}
        contactInfoEmailLabel={t('MA_EMAIL')}
        contactInfoWebsiteLabel={t('CU_WEBSITE')}
        contactInfoTitle={`${t('CUSTOMER_SERVICE')}:`}
        returnContactUrl={returnContactUrl}
        servicesOfferedTitle={`${t('SERVICES_OFFERED')}:`}
        storeHoursOpen24HrsTitle={t('OPEN_24_HOURS_7_DAYS_A_WEEK')}
        storeHoursTitle={`${t('STORE_HOURS')}:`}
      />
    </>
  );
};
